var exports = {
  "kL": "container__mwms4Q",
  "nM": "row__xbD5a9",
  "Vg": "grid__U9thpW",
  "DD": "title__o7xkgB",
  "P$": "compressedHeader__JtWO3K",
};

module.exports = exports;
